const request = require('request')

async function sendEmail(data) {
	const response = await request.post(
		'https://f7i47tirj1.execute-api.us-east-1.amazonaws.com/non-prod/sendemail',
		{
			method: 'POST',
			headers: {
				'x-api-key': 'l2BNsHDzEorEKa3kYMRX3htYDu4ctUw2vSYGQwif',
			},
			body: JSON.stringify(data),
		},
		function (err, data) {
			console.log(err, data)
		}
	)

	return response
}

export default sendEmail
